import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { URLS } from "../constants/constants";
import { ChangePasswordDto } from "./dto/change-password.dto";
import { ChangePasswordResponseDto } from "./dto/change-password.response.dto";
import { AuthService } from "../../common/services/auth.service";

@Injectable()
export class ChangePasswordService {
    private authService = inject(AuthService);
    private http = inject(HttpClient);

    changePassword(changePasswordDto: ChangePasswordDto): Promise<ChangePasswordResponseDto>{
       return firstValueFrom(this.http.post<ChangePasswordResponseDto>(
        `${URLS.CHANGE_PASSWORD_API}`,
        changePasswordDto, 
        {
            headers: this.authService.getAuthHeaders()
        }));  
    }
}